module.exports = __webpack_public_path__ + "static/services-banner-2ffa2223c181ea65ab0e32c273d6eb63.jpg";